// extracted by mini-css-extract-plugin
export var addressFields = "_pa-0";
export var animationContainer = "_pa-1";
export var footer = "_pa-2";
export var lineItems = "_pa-3";
export var modalContent = "_pa-4";
export var orderName = "_pa-5";
export var strong = "_pa-6";
export var warning = "_pa-7";